(() => {
  document.documentElement.classList.remove('no-js');

  const announce = (message) => {
    const region = document.querySelector('[data-live-region]');
    if (region) region.textContent = message;
  };

  const track = (name, detail = {}) => {
    if (document.documentElement.dataset.analytics !== 'true') return;
    const payload = { event: `lovemy_${name}`, ...detail };
    window.dispatchEvent(new CustomEvent('lovemy:event', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  };

  window.LoveMy = { announce, track };

  document.addEventListener('click', (event) => {
    const drawerOpen = event.target.closest('[data-drawer-open]');
    const drawerClose = event.target.closest('[data-drawer-close]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    if (drawerOpen && drawer) {
      drawerOpen.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('open', '');
      document.body.classList.add('menu-open');
      drawer.querySelector('.mobile-drawer__panel [data-drawer-close]')?.focus();
    }
    if (drawerClose && drawer) {
      document.querySelector('[data-drawer-open]')?.setAttribute('aria-expanded', 'false');
      drawer.removeAttribute('open');
      document.body.classList.remove('menu-open');
      document.querySelector('[data-drawer-open]')?.focus();
    }

    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const input = quantityButton.parentElement?.querySelector('input[type="number"]');
      if (input) {
        const next = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(quantityButton.dataset.quantityChange));
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const filterToggle = event.target.closest('[data-filter-toggle]');
    if (filterToggle) {
      const facets = document.querySelector('[data-facets]');
      facets?.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', facets?.classList.contains('is-open') ? 'true' : 'false');
    }

    const horizontalButton = event.target.closest('[data-horizontal-prev], [data-horizontal-next]');
    if (horizontalButton) {
      const scroller = horizontalButton.closest('.fragrance-types')?.querySelector('[data-horizontal-scroll]');
      if (scroller) {
        const direction = horizontalButton.hasAttribute('data-horizontal-prev') ? -1 : 1;
        scroller.scrollBy({ left: direction * scroller.clientWidth * .82, behavior: 'smooth' });
      }
    }

    const whatsapp = event.target.closest('[data-whatsapp]');
    if (whatsapp) track('whatsapp_click', { context: whatsapp.dataset.context || 'general' });
    const checkout = event.target.closest('[data-checkout]');
    if (checkout) track('begin_checkout', { cart_value: checkout.closest('form')?.dataset.cartValue || '' });
  });

  document.addEventListener('keydown', (event) => {
    const drawer = document.querySelector('[data-mobile-drawer][open]');
    if (!drawer) return;
    const focusables = Array.from(drawer.querySelectorAll('.mobile-drawer__panel a, .mobile-drawer__panel button, .mobile-drawer__panel summary')).filter(el => el.getClientRects().length);
    if (event.key === 'Escape') { drawer.removeAttribute('open'); document.body.classList.remove('menu-open'); const trigger = document.querySelector('[data-drawer-open]'); trigger?.setAttribute('aria-expanded', 'false'); trigger?.focus(); }
    if (event.key === 'Tab' && focusables.length) { const first = focusables[0], last = focusables[focusables.length - 1]; if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); } else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); } }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ajax-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Añadiendo…'; }
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      if (!response.ok) throw new Error(response.status === 422 ? 'La cantidad solicitada no está disponible. Revise su pedido.' : 'No pudimos añadir el perfume. Intente nuevamente.');
      const item = await response.json();
      track('add_to_cart', { variant_id: item.variant_id, product_id: item.product_id, quantity: item.quantity });
      announce(`${item.product_title} se añadió al carrito`);
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (error) {
      announce(error.message);
      let feedback = form.querySelector('[data-cart-error]');
      if (!feedback) { feedback = document.createElement('p'); feedback.dataset.cartError = ''; feedback.className = 'cart-error'; feedback.setAttribute('role', 'alert'); form.append(feedback); }
      feedback.textContent = error.message;
      if (button) button.textContent = 'Intenta nuevamente';
    } finally {
      if (button) { button.disabled = false; if (button.textContent !== 'Intenta nuevamente') button.textContent = original; }
    }
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    track('view_product', { product_id: root.dataset.productId });
    const dataElement = root.querySelector('[data-variants-json]');
    if (!dataElement) return;
    let variants = [];
    try { variants = JSON.parse(dataElement.textContent); } catch (_) { return; }
    const form = root.querySelector('[data-ajax-product-form]');
    const idInput = form?.querySelector('[name="id"]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const submit = form?.querySelector('[type="submit"]');
    const versionDialog = root.querySelector('[data-version-dialog]');
    const versionPanels = versionDialog?.querySelectorAll('[data-version-panel]') || [];
    const selectedVariant = () => variants.find((item) => String(item.id) === String(idInput?.value));
    const versionKind = (title = '') => {
      const normalized = title.toLowerCase();
      if (normalized.includes('top quality')) return 'top-quality';
      if (normalized.includes('original')) return 'original';
      return '';
    };
    const openVersionDialog = (variant) => {
      if (!versionDialog || !variant) return;
      const kind = versionKind(variant.title);
      if (!kind) return;
      versionPanels.forEach((panel) => { panel.hidden = panel.dataset.versionPanel !== kind; });
      versionDialog.setAttribute('aria-labelledby', kind === 'original' ? `VersionDialogTitle-${root.dataset.sectionId || ''}` : `VersionDialogTitleTop-${root.dataset.sectionId || ''}`);
      if (typeof versionDialog.showModal === 'function') versionDialog.showModal();
      else versionDialog.setAttribute('open', '');
      document.body.classList.add('dialog-open');
      track('version_info_opened', { product_id: root.dataset.productId, variant_id: variant.id, version: variant.title });
    };

    root.querySelector('[data-version-info-open]')?.addEventListener('click', () => openVersionDialog(selectedVariant()));
    versionDialog?.querySelectorAll('[data-version-dialog-close]').forEach((button) => {
      button.addEventListener('click', () => {
        if (typeof versionDialog.close === 'function') versionDialog.close();
        else versionDialog.removeAttribute('open');
        document.body.classList.remove('dialog-open');
      });
    });
    versionDialog?.addEventListener('click', (event) => {
      if (event.target !== versionDialog) return;
      if (typeof versionDialog.close === 'function') versionDialog.close();
      else versionDialog.removeAttribute('open');
      document.body.classList.remove('dialog-open');
    });
    versionDialog?.addEventListener('close', () => document.body.classList.remove('dialog-open'));

    root.querySelectorAll('[data-variant-input]').forEach((input) => {
      input.addEventListener('change', () => {
        const variant = variants.find((item) => String(item.id) === input.value);
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (price) price.textContent = variant.price_formatted;
        if (compare) { compare.textContent = variant.compare_at_price_formatted || ''; compare.hidden = !variant.compare_at_price_formatted; }
        if (submit) { submit.disabled = !variant.available; submit.textContent = variant.available ? 'Añadir al carrito' : 'Agotado'; }
        const media = root.querySelector('[data-primary-media]');
        if (media && variant.image_url) { media.src = variant.image_url; media.removeAttribute('srcset'); media.alt = variant.image_alt || ''; }
        const stock = root.querySelector('[data-product-stock]');
        if (stock) stock.textContent = variant.available ? 'Disponible' : 'Agotado';
        const whatsappLink = root.querySelector('[data-product-whatsapp]');
        if (whatsappLink) {
          const target = new URL(whatsappLink.href);
          const productUrl = new URL(window.location.href); productUrl.searchParams.set('variant', variant.id);
          target.searchParams.set('text', `Hola LoveMy Beauty, quiero comprar ${root.querySelector('h1')?.textContent?.trim() || 'este perfume'} en la versión ${variant.title}. ¿Me confirman disponibilidad y entrega? ${productUrl}`);
          whatsappLink.href = target;
        }
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
        track('version_selected', { product_id: root.dataset.productId, variant_id: variant.id, version: variant.title });
        openVersionDialog(variant);
      });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const image = gallery.querySelector('[data-primary-media]');
    const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');
    if (!image || !thumbnails.length) return;
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const source = thumbnail.dataset.gallerySrc;
        if (!source) return;
        image.src = source;
        image.removeAttribute('srcset');
        image.alt = thumbnail.dataset.galleryAlt || '';
        thumbnails.forEach((item) => item.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
      });
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href); url.searchParams.set('sort_by', select.value); track('sort_used', { value: select.value }); window.location.assign(url);
    });
  });

  document.querySelectorAll('[data-facet-form]').forEach((form) => {
    let filterTimer;
    form.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="checkbox"], input[type="radio"], input[type="number"], select')) return;
      window.clearTimeout(filterTimer);
      form.setAttribute('aria-busy', 'true');
      filterTimer = window.setTimeout(() => {
        track('filter_used', { filter: event.target.name || '' });
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }, 180);
    });
  });

  document.querySelectorAll('form[action="/search"], form[action$="/search"]').forEach((form) => {
    form.addEventListener('submit', () => track('search', { query: form.querySelector('[name="q"]')?.value || '' }));
  });

  document.querySelectorAll('[data-recommendations-url]').forEach(async (section) => {
    if (section.innerHTML.trim()) return;
    try {
      const response = await fetch(section.dataset.recommendationsUrl);
      if (!response.ok) return;
      const html = document.createElement('div'); html.innerHTML = await response.text();
      const replacement = html.querySelector('[data-recommendations-url]');
      if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    } catch (_) {}
  });

})();

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      if (!this.form || !this.input || !this.panel) return;

      this.abort = new AbortController();
      this.request = null;
      this.timer = null;
      const signal = this.abort.signal;

      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        const query = this.input.value.trim();
        if (query.length < 2) {
          this.close();
          return;
        }
        this.timer = setTimeout(() => this.search(query), 220);
      }, { signal });

      this.input.addEventListener('focus', () => {
        if (this.suppressFocusOpen) {
          this.suppressFocusOpen = false;
          return;
        }
        if (this.input.value.trim().length >= 2 && this.panel.childElementCount) this.open();
      }, { signal });

      this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.close();
      }, { signal });
    }

    async search(query) {
      this.request?.abort();
      this.request = new AbortController();
      this.status.textContent = this.dataset.loading;
      const parameters = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,vendor,product_type,variants.title'
      });

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}search/suggest.json?${parameters}`, {
          headers: { Accept: 'application/json' },
          signal: this.request.signal
        });
        if (!response.ok) throw new Error('Predictive search failed');
        const data = await response.json();
        if (query !== this.input.value.trim()) return;
        this.render(data.resources?.results?.products || [], query);
      } catch (error) {
        if (error.name !== 'AbortError') this.close();
      }
    }

    render(products, query) {
      this.panel.replaceChildren();
      if (!products.length) {
        const message = document.createElement('p');
        message.className = 'predictive-search__message';
        message.textContent = this.dataset.noResults;
        this.panel.append(message);
        this.status.textContent = this.dataset.noResults;
        this.open();
        return;
      }

      const heading = document.createElement('p');
      heading.className = 'predictive-search__heading';
      heading.textContent = `${products.length} ${this.dataset.results}`;
      const list = document.createElement('ul');
      list.className = 'predictive-search__list';
      list.setAttribute('role', 'listbox');

      products.forEach((product, index) => {
        const item = document.createElement('li');
        item.className = 'predictive-search__item';
        item.setAttribute('role', 'presentation');
        const link = document.createElement('a');
        link.className = 'predictive-search__link';
        link.href = product.url;
        link.id = `${this.panel.id}-option-${index}`;
        link.setAttribute('role', 'option');

        const imageUrl = product.featured_image?.url || product.image;
        if (imageUrl) {
          const image = document.createElement('img');
          image.className = 'predictive-search__image';
          image.src = imageUrl;
          image.alt = '';
          image.width = 58;
          image.height = 58;
          image.loading = 'lazy';
          link.append(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'predictive-search__image predictive-search__image--empty';
          placeholder.setAttribute('aria-hidden', 'true');
          link.append(placeholder);
        }

        const content = document.createElement('span');
        content.className = 'predictive-search__content';
        const vendor = document.createElement('span');
        vendor.className = 'predictive-search__vendor';
        vendor.textContent = product.vendor || '';
        const title = document.createElement('span');
        title.className = 'predictive-search__title';
        title.textContent = product.title;
        content.append(vendor, title);

        const price = document.createElement('span');
        price.className = 'predictive-search__price';
        const amount = Number(product.price);
        if (Number.isFinite(amount)) {
          price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es-EC', {
            style: 'currency',
            currency: this.dataset.currency || 'USD'
          }).format(amount);
        }
        link.append(content);
        item.append(link);
        list.append(item);
      });

      const allResults = document.createElement('a');
      allResults.className = 'predictive-search__all';
      const searchUrl = new URL(this.form.action, window.location.origin);
      searchUrl.searchParams.set('q', query);
      searchUrl.searchParams.set('type', 'product');
      allResults.href = searchUrl;
      allResults.textContent = `${this.dataset.viewAll} “${query}” →`;
      this.panel.append(heading, list, allResults);
      this.status.textContent = heading.textContent;
      this.open();
    }

    onKeydown(event) {
      const options = Array.from(this.panel.querySelectorAll('a'));
      if (!options.length || this.panel.hidden) return;
      const current = options.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        event.preventDefault();
        this.suppressFocusOpen = true;
        this.close();
        this.input.focus();
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        options[current < options.length - 1 ? current + 1 : 0].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (current <= 0) this.input.focus();
        else options[current - 1].focus();
      }
    }

    open() {
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.abort?.abort();
    }
  });
}

